import React, { createContext, useContext, useState, useCallback } from 'react';
import Alert from 'src/components/alert';

type AlertType = 'error' | 'info' | 'warning' | 'success';

interface AlertContextProps {
  showAlert: (title: string, message: string, type: AlertType) => void;
}

const AlertContext = createContext<AlertContextProps | undefined>(undefined);

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};

export const AlertProvider: React.FC = ({ children }: any) => {
  const [alert, setAlert] = useState<{title: string, message: string; type: AlertType } | null>(null);

  const showAlert = useCallback((title: string, message: string, type: AlertType) => {
    setAlert({title, message, type });
    setTimeout(() => {
      setAlert(null);
    }, 5000);
  }, []);

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {alert && <Alert title={alert.title} message={alert.message} type={alert.type} />}
    </AlertContext.Provider>
  );
};